module.exports = __webpack_public_path__ + "img/bg_banner_faq_page_1.d0c70047.png";